import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "onClose", "title", "showCloseButton", "size", "overlay", "closeOnOverlayClick", "isCentered", "focusRef", "blockScrolling", "children", "modalHeaderProps", "modalBodyProps", "modalOverlayProps", "modalContentProps", "modalCloseButtonProps"];
import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';
export var getChakraSize = function getChakraSize(size) {
  switch (size) {
    case 'small':
      return 'xs';
    case 'medium':
      return '3xl';
    case 'large':
      return '6xl';
    case 'full-screen':
      return 'full';
    default:
      return 'md';
  }
};
export function ModalDialog(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    title = _ref.title,
    showCloseButton = _ref.showCloseButton,
    size = _ref.size,
    overlay = _ref.overlay,
    closeOnOverlayClick = _ref.closeOnOverlayClick,
    isCentered = _ref.isCentered,
    focusRef = _ref.focusRef,
    blockScrolling = _ref.blockScrolling,
    children = _ref.children,
    modalHeaderProps = _ref.modalHeaderProps,
    modalBodyProps = _ref.modalBodyProps,
    modalOverlayProps = _ref.modalOverlayProps,
    modalContentProps = _ref.modalContentProps,
    modalCloseButtonProps = _ref.modalCloseButtonProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var contentRef = /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement(Modal, _extends({
    onClose: onClose,
    isOpen: isOpen,
    autoFocus: false,
    initialFocusRef: focusRef || contentRef,
    blockScrollOnMount: blockScrolling !== null && blockScrolling !== void 0 ? blockScrolling : true,
    closeOnOverlayClick: closeOnOverlayClick !== null && closeOnOverlayClick !== void 0 ? closeOnOverlayClick : true,
    isCentered: size === 'full-screen' || (isCentered !== null && isCentered !== void 0 ? isCentered : false),
    scrollBehavior: "inside",
    size: getChakraSize(size)
  }, props, {
    "data-testid": "molecules-ModalDialog-Modal"
  }), overlay && /*#__PURE__*/React.createElement(ModalOverlay, modalOverlayProps), /*#__PURE__*/React.createElement(ModalContent, _extends({
    ref: contentRef
  }, modalContentProps), title && /*#__PURE__*/React.createElement(ModalHeader, modalHeaderProps, title), showCloseButton && /*#__PURE__*/React.createElement(ModalCloseButton, modalCloseButtonProps), /*#__PURE__*/React.createElement(ModalBody, modalBodyProps, children)));
}